<ng-container [formGroup]="inventoryForm" *ngIf="dialogData.locations && dialogData.locations.length > 0">
    <h3 class="form-header" *ngIf="!data" i18n="@@71641abe42893a23a500a4dbf647735c066fa1a7"
        t="71641abe42893a23a500a4dbf647735c066fa1a7">
        Add Tire Inventory
    </h3>
    <h3 class="form-header" *ngIf="data" i18n="@@e4da8800344a56d34db301e5cca3d5eed6e5fc4f"
        t="e4da8800344a56d34db301e5cca3d5eed6e5fc4f">
        Edit Tire Inventory
    </h3>

    <div class="grid">
        <!-- Location and Model -->
        <div class="row">
            <div fxFlex="50">
                <tsl-form-field fxFlex="90">
                    <tsl-label i18n="@@ed31c09fd77c36238c13d83635f3fe5294c733d2"
                        t="ed31c09fd77c36238c13d83635f3fe5294c733d2">Location</tsl-label>
                    <tsl-select triggerIcon="location_on" formControlName="location"
                        (selectionChange)="onLocationChange($event)" required>
                        <tsl-option *ngFor="let location of dialogData.locations" [value]="location">
                            {{ location.address }}
                        </tsl-option>
                    </tsl-select>
                    <tsl-error *ngIf="
                            inventoryForm.get('location').errors &&
                            (inventoryForm.get('location').dirty || inventoryForm.get('location').touched)
                        ">
                        <span i18n="@@bf390eb9c62fed91d148538dffc37583439f243d"
                            t="bf390eb9c62fed91d148538dffc37583439f243d">
                            Location is Required
                        </span>
                    </tsl-error>
                </tsl-form-field>
            </div>
            <div fxFlex="50">
                <tsl-form-field fxFlex="90">
                    <tsl-label i18n="@@6ec98fa3d6504ba1fd03465194b53706c8263c99"
                        t="6ec98fa3d6504ba1fd03465194b53706c8263c99">Model</tsl-label>
                    <tsl-select formControlName="model" (selectionChange)="onModelChange($event)" required>
                        <tsl-option *ngFor="let model of models" [value]="model">
                            <span>
                                {{ translateService.get(model.name) }}
                            </span>
                            <span *ngIf="model && model.variantProviderText">
                                - {{ translateService.get(model.variantProviderText) }}
                            </span>
                        </tsl-option>
                    </tsl-select>
                    <tsl-error *ngIf="
                            inventoryFormControls.model.errors &&
                            (inventoryFormControls.model.dirty || inventoryFormControls.model.touched)
                        ">
                        <span i18n="@@9992252d78ac0af303551d40c9838a2b98d59f8b"
                            t="9992252d78ac0af303551d40c9838a2b98d59f8b">Model is Required</span>
                    </tsl-error>
                </tsl-form-field>
            </div>
        </div>

        <!-- Tire Size/Quantity fields -->
        <div class="row">
            <div fxFlex="50">
                <tsl-form-field fxFlex="90">
                    <tsl-label i18n="@@3ad1d838b44d79edfc181316fa94c26ad69e97de"
                        t="3ad1d838b44d79edfc181316fa94c26ad69e97de">Tire Size</tsl-label>
                    <tsl-select formControlName="tiresize" required>
                        <tsl-option *ngFor="let tire of filteredSizes" [value]="tire">
                            {{ translateService.get(tire.name) }}
                        </tsl-option>
                    </tsl-select>
                    <tsl-error *ngIf="
                            inventoryFormControls.tiresize.errors &&
                            (inventoryFormControls.tiresize.dirty || inventoryFormControls.tiresize.touched)
                        ">
                        <span i18n="@@fcad08174e72491d372514d751a449d3a3385f4b"
                            t="fcad08174e72491d372514d751a449d3a3385f4b">Tire Size is Required</span>
                    </tsl-error>
                </tsl-form-field>
            </div>
            <div fxFlex="50">
                <tsl-form-field fxFlex="90">
                    <tsl-label i18n="@@ca30c1aa79fb5ab487fbd2caa4ca01f2f6691d70"
                        t="ca30c1aa79fb5ab487fbd2caa4ca01f2f6691d70">Quantity</tsl-label>
                    <input id="quantity" tslInput fullWidth maxlength="50" formControlName="quantity" required />
                    <tsl-error *ngIf="
                            inventoryFormControls.quantity.errors &&
                            inventoryFormControls.quantity.errors.required &&
                            (inventoryFormControls.quantity.dirty || inventoryFormControls.quantity.touched)
                        ">
                        <span i18n="@@1236d364c4c9000b25e2a147cd88911dda0c880e"
                            t="1236d364c4c9000b25e2a147cd88911dda0c880e">Quantity is Required</span>
                    </tsl-error>
                    <tsl-error *ngIf="
                            inventoryFormControls.quantity.errors &&
                            !inventoryFormControls.quantity.errors.required &&
                            inventoryFormControls.quantity.errors.pattern
                        ">
                        <span i18n="@@d7c81b8fec158ca0d108a97ca10267cf1cb8e384"
                            t="d7c81b8fec158ca0d108a97ca10267cf1cb8e384">Only numbers are allowed.</span>
                    </tsl-error>
                </tsl-form-field>
            </div>
        </div>
    </div>

    <!-- Action Buttons -->
    <div class="left" style="padding-top: 20px;">
        <button tsl-button size="small" color="blue" filled [disabled]="inventoryForm.invalid" (click)="save()"
            i18n="@@52c9a103b812f258bcddc3d90a6e3f46871d25fe" t="52c9a103b812f258bcddc3d90a6e3f46871d25fe">
            Save
        </button>
        <button tsl-button size="small" color="black" outline (click)="onClose()"
            i18n="@@d7b35c384aecd25a516200d6921836374613dfe7" t="d7b35c384aecd25a516200d6921836374613dfe7">
            Cancel
        </button>
    </div>
</ng-container>
<ng-container *ngIf="dialogData.locations && dialogData.locations.length <= 0">
    <div>
        <span i18n="@@d7aafacb35fe5467d4c09a1f14d24a320f2d4cef" t="d7aafacb35fe5467d4c09a1f14d24a320f2d4cef">
            No locations found. </span><br />
        <span i18n="@@9bf7a5459426fb66f89c071540ffa1c5e2a28dd4" t="9bf7a5459426fb66f89c071540ffa1c5e2a28dd4">To add
            locations or for any assistance please contact your company's Regional Network Manager.</span>
    </div>
    <!-- Action Buttons -->
    <div class="right" style="padding-top: 20px;">
        <button tsl-button size="small" color="black" outline (click)="onClose()">Cancel</button>
    </div>
</ng-container>